import { TsDOM as q } from '@/scripts/core/TsDOM'
import { ProductPersonalizationPage } from '@/scripts/product/product-personalization-page'

q.safeDefineElement(ProductPersonalizationPage)
